export const guidelinesLink =
  'https://syte-knowledge-center.refined.site/space/SI/2738290693/Introduction+to+Products+Feed';
